module.exports = __webpack_public_path__ + "assets/dripicons-v2.835984438066bd8944a7692e331152a7.svg";